import React from "react";
import styles from "./AboutSection.module.css";
import { ABOUT_HTML, WHY_HTML } from "../../../content/marketingCopy";

export default function AboutSection() {
  return (
    <section
      id="about"
      className={`py-5 py-lg-6 ${styles.about}`}
      aria-labelledby="about-heading"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-9 col-xl-8">
            {/* About header */}
            <header className="text-center mb-4">
              <h2 id="about-heading" className={`fw-bold ${styles.heading}`}>
                About Pocket&nbsp;Penny
              </h2>
              <p className={`mb-0 text-body-secondary ${styles.subhead}`}>
                A smarter way to understand and plan your money
              </p>
            </header>

            {/* About copy */}
            <div
              className={styles.copy}
              dangerouslySetInnerHTML={{ __html: ABOUT_HTML }}
            />

            {/* Why plan ahead (single heading; render WHY_HTML content only) */}
            <div className="mt-5">
              <header className="text-center mb-3">
                <h3 className={`fw-bold ${styles.whyHeading}`} id="why-heading">
                  Why plan ahead?
                </h3>
              </header>

              <div
                className={styles.whyCard}
                aria-labelledby="why-heading"
                // WHY_HTML already includes its own h2; we'll visually down-rank it via CSS
                dangerouslySetInnerHTML={{ __html: WHY_HTML }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
